<script setup lang="ts">
/**
 * Бейдж роли **в мероприятии**: владелец / наблюдатель+ / наблюдатель.
 *
 * ⚠️ Это роль пары (мероприятие, пользователь). У одного и того же человека она
 * разная в разных соревнованиях, и в токене её нет. Системная роль — в
 * `SystemRoleBadge`, роль участника из справочника — вообще не про права.
 *
 * ⚠️ «Наблюдатель+» НАРИСОВАН КАК НАБЛЮДАТЕЛЬ, А НЕ КАК ПОЛУВЛАДЕЛЕЦ, и это
 * решение, а не нехватка вариантов бейджа. Он и есть наблюдатель — с ровно
 * одним дополнительным правом: отмечать графы, подсвеченные для сканирования.
 * Заливка `default`, как у владельца, читалась бы «почти владелец» и
 * подталкивала бы отдавать эту роль там, где хватает обычного наблюдателя.
 * Поэтому тот же нейтральный `secondary`, что у наблюдателя, а отличает их
 * подпись — «+» на конце.
 */
import { computed } from 'vue'
import type { BadgeVariants } from '@/components/ui/badge'
import { Badge } from '@/components/ui/badge'
import { MEMBER_ROLE_LABELS } from '@/types/api'

const props = defineProps<{
  role: string
}>()

const VARIANTS: Record<string, BadgeVariants['variant']> = {
  MEMBER_ROLE_OWNER: 'default',
  MEMBER_ROLE_VIEWER: 'secondary',
  // См. шапку: визуально это наблюдатель, а не половина владельца.
  MEMBER_ROLE_VIEWER_PLUS: 'secondary',
}

const view = computed(() => {
  const label = MEMBER_ROLE_LABELS[props.role as keyof typeof MEMBER_ROLE_LABELS]
  return label && props.role !== 'MEMBER_ROLE_UNSPECIFIED'
    ? { label, variant: VARIANTS[props.role] }
    : { label: props.role, variant: 'outline' as const }
})
</script>

<template>
  <Badge :variant="view.variant">
    {{ view.label }}
  </Badge>
</template>
